export default "__VITE_ASSET__zw6YUUFA__"